import React, { useState, useEffect } from 'react';
import { Form, FormField, FormLabel, FormInput, FormTextarea, Button } from '../ui';
import type { SurveyQuestionnaire, QuestionnaireFormData } from '../../types/survey';

interface QuestionnaireFormProps {
  questionnaire?: SurveyQuestionnaire | null;
  onSubmit: (data: QuestionnaireFormData) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export const QuestionnaireForm: React.FC<QuestionnaireFormProps> = ({
  questionnaire,
  onSubmit,
  onCancel,
  isLoading,
}) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    if (questionnaire) {
      setTitle(questionnaire.title);
      setDescription(questionnaire.description || '');
    } else {
      setTitle('');
      setDescription('');
    }
    setErrors({});
  }, [questionnaire]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const errs: Record<string, string> = {};
    if (!title.trim()) errs.title = 'Título é obrigatório';
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }
    onSubmit({ title: title.trim(), description: description.trim() || undefined });
  };

  return (
    <Form onSubmit={handleSubmit} className="space-y-4">
      <FormField>
        <FormLabel htmlFor="title" required>Título</FormLabel>
        <FormInput
          id="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Título do questionário"
          error={!!errors.title}
          validationError={errors.title}
        />
      </FormField>

      <FormField>
        <FormLabel htmlFor="description">Descrição</FormLabel>
        <FormTextarea
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Descrição opcional"
          rows={3}
        />
      </FormField>

      <div className="flex justify-end gap-3 pt-2">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancelar
        </Button>
        <Button type="submit" isLoading={isLoading}>
          {questionnaire ? 'Salvar' : 'Criar'}
        </Button>
      </div>
    </Form>
  );
};
